export default "__VITE_ASSET__DGCL52Dz__"